export interface UserCreditDTO {
  idUser: number;
  fullName: string;
  email: string;
  monthlyTokenLimit: number;
  usedThisMonth: number;
  remaining: number;
}

export interface UserCreditMeDTO {
  monthlyTokenLimit: number;
  usedThisMonth: number;
  remaining: number;
}

export interface MonthlyAccountUsageDTO {
  year: number;
  month: number;
  inputTokens: number;
  outputTokens: number;
}

export interface UpsertCreditRequest {
  monthlyTokenLimit: number;
}

export interface UserOption {
  id: number;
  email: string;
}

export class AiCreditApiWrapper {
  private baseUrl: string;
  private getApiKey: (key: string) => Promise<string>;

  constructor(baseUrl: string, getApiKey: (key: string) => Promise<string>) {
    this.baseUrl = baseUrl;
    this.getApiKey = getApiKey;
  }

  private async headers(): Promise<Record<string, string>> {
    const [authorization, userentity, referer] = await Promise.all([
      this.getApiKey('Authorization'),
      this.getApiKey('Userentity'),
      this.getApiKey('Referer'),
    ]);
    return { Authorization: authorization, Userentity: userentity, Referer: referer, 'Content-Type': 'application/json' };
  }

  async getAll(): Promise<UserCreditDTO[]> {
    const res = await fetch(`${this.baseUrl}/api/v1/AiCredit`, { headers: await this.headers() });
    if (!res.ok) throw new Error(`AiCredit getAll failed: ${res.status}`);
    return res.json();
  }

  async getMe(): Promise<UserCreditMeDTO> {
    const res = await fetch(`${this.baseUrl}/api/v1/AiCredit/me`, { headers: await this.headers() });
    if (!res.ok) throw new Error(`AiCredit getMe failed: ${res.status}`);
    return res.json();
  }

  async getMonthlyUsage(months = 12): Promise<MonthlyAccountUsageDTO[]> {
    const res = await fetch(`${this.baseUrl}/api/v1/AiCredit/usage/monthly?months=${months}`, { headers: await this.headers() });
    if (!res.ok) throw new Error(`AiCredit monthly usage failed: ${res.status}`);
    return res.json();
  }

  async getUserOptions(search: string): Promise<UserOption[]> {
    const res = await fetch(`${this.baseUrl}/api/v1/User/typeahead/${encodeURIComponent(search)}`, { headers: await this.headers() });
    if (!res.ok) throw new Error(`User typeahead failed: ${res.status}`);
    const json = await res.json();
    const items: any[] = json?.data ?? [];
    return items
      .filter((u: any) => u.id && u.email)
      .map((u: any) => ({ id: u.id, email: u.email ?? '' }));
  }

  async upsertCredit(idUserEntity: number, body: UpsertCreditRequest): Promise<void> {
    const res = await fetch(`${this.baseUrl}/api/v1/AiCredit/${idUserEntity}`, {
      method: 'PUT',
      headers: await this.headers(),
      body: JSON.stringify(body),
    });
    if (!res.ok) throw new Error(`AiCredit upsert failed: ${res.status}`);
  }
}
